<div id="cris-layout-leading" class="d-flex flex-column mt-5">
  <div class="container text-right">
    <ds-context-menu *ngIf="showContextMenu" [contextMenuObject]="item" [contextMenuObjectType]="'ITEM'"></ds-context-menu>
  </div>
	<ds-cris-layout-matrix *ngIf="tab" [tab]="tab" [item]="item"></ds-cris-layout-matrix>
</div>
